/**
 * Guardia delle pagine riservate agli amministratori della piattaforma.
 *
 * Il menu non propone queste pagine a chi non ha il ruolo `ADMIN`, ma un
 * indirizzo si può sempre scrivere a mano o ricevere da un collega. In quel
 * caso la pagina dice subito che cosa manca, invece di caricare e mostrare una
 * sfilza di rifiuti del backend. Il controllo vero resta del backend: questa
 * guardia evita solo richieste destinate a un 403.
 *
 * La spiegazione si carica a richiesta (`AdminOnlyPage`): la guardia sta nel
 * chunk iniziale, e il `Result` di antd non deve starci.
 */

import { Skeleton } from 'antd';
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { useIsPlatformAdmin } from '../auth/roles';

const AdminOnlyPage = lazy(async () => ({ default: (await import('./AdminOnlyPage')).AdminOnlyPage }));

/**
 * Lascia passare solo gli amministratori della piattaforma.
 *
 * @returns Le rotte figlie, oppure la spiegazione del permesso mancante.
 */
export function RequireAdmin(): JSX.Element {
  const admin = useIsPlatformAdmin();
  if (!admin) {
    return (
      <Suspense fallback={<Skeleton active />}>
        <AdminOnlyPage />
      </Suspense>
    );
  }
  return <Outlet />;
}
